import { BellRing, Coffee, Car, Wifi, Heater, MountainSnow, UtensilsCrossed, ShieldCheck } from "lucide-react";
import Reveal from "./Reveal";
import { AMENITIES } from "../data/content";

const ICONS = { BellRing, Coffee, Car, Wifi, Heater, MountainSnow, UtensilsCrossed, ShieldCheck };

const Amenities = () => (
  <section id="amenities" data-testid="amenities-section" className="mx-auto max-w-7xl px-5 py-24 sm:px-8 lg:py-32">
    <Reveal>
      <div className="mb-14 text-center">
        <p className="text-[11px] font-medium uppercase tracking-[0.35em] text-[#C5A059]">Signature Amenities</p>
        <h2 className="mt-4 font-display text-4xl font-light text-[#F5F2EB] sm:text-5xl">Everything, Quietly Perfected</h2>
      </div>
    </Reveal>
    <div className="grid grid-cols-1 gap-px border border-[#2A2421] bg-[#2A2421] sm:grid-cols-2 lg:grid-cols-4">
      {AMENITIES.map((a, i) => {
        const Icon = ICONS[a.icon];
        return (
          <Reveal key={a.title} delay={(i % 4) * 0.08}>
            <div data-testid={`amenity-${a.icon.toLowerCase()}`} className="group h-full bg-[#0D0B0A] p-8 transition-colors duration-500 hover:bg-[#161311]">
              <Icon size={26} strokeWidth={1.4} className="text-[#C5A059] transition-transform duration-500 group-hover:-translate-y-1" />
              <h3 className="mt-5 font-display text-xl text-[#F5F2EB]">{a.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-[#A8A29E]">{a.text}</p>
            </div>
          </Reveal>
        );
      })}
    </div>
  </section>
);

export default Amenities;
